import { render, staticRenderFns } from "./supAddress.vue?vue&type=template&id=a829921c&scoped=true"
import script from "./supAddress.vue?vue&type=script&lang=js"
export * from "./supAddress.vue?vue&type=script&lang=js"
import style0 from "./supAddress.vue?vue&type=style&index=0&id=a829921c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a829921c",
  null
  
)

export default component.exports